import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { HttpService } from "./http.service";
import { Observable } from "rxjs";
import { CountryDto } from "app/models";
import { ConfigurationService } from "./configuration.service";

@Injectable()
export class CountryService extends BaseService {
     constructor(httpService: HttpService,
            configurationService: ConfigurationService) {
                super(httpService, configurationService);
        }
    
        getActiveCountries(): Observable<CountryDto[]> {
            return this.httpService.get<CountryDto[]>(this.apiUrl + 'countries/active', null);
        }
    
}